import { render } from "./CompanyActions.vue?vue&type=template&id=390e82a6"
import script from "./CompanyActions.vue?vue&type=script&lang=js"
export * from "./CompanyActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__